import { all, put, takeLatest } from "redux-saga/effects";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import DashboardService from "../../services/DashboardService";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import {
  componentKey,
  setDashboardData,
  setVisitList,
  setFacilityRooms,
  setIcdSummary,
} from "./dashboardSlice";
import store from "../../store/store";

export const {
  getDashboardData,
  getVisitList,
  getFacilityRooms,
  getIcdSummary,
} = {
  getDashboardData: (payload) => {
    return {
      type: "PATIENT/GET_DASHBOARD_COUNT",
      payload,
    };
  },
  getVisitList: (payload) => {
    return {
      type: "PATIENT/GET_VISIT_LIST",
      payload,
    };
  },
  getFacilityRooms: (payload) => {
    return {
      type: "PATIENT/GET_FACILITY_ROOMS",
      payload,
    };
  },
  getIcdSummary: (payload) => {
    return {
      type: "PATIENT/GET_ICD_SUMMARY",
      payload,
    };
  },
};

// SEARCH PARTICIPANT API CALL FUNCTION
function* getDashboardCountAsync(action) {
  // Silent polling (auto-refresh) skips the global loader.
  const silent = action?.payload?.silent;
  try {
    if (!silent) yield put(showLoader());
    const response = yield DashboardService.getDashboardData(action?.payload);
    const { status } = response;
    if (status) {
      const { data } = response;
      yield put(setDashboardData(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setDashboardData({}));

    console.log("err: ", error);
  } finally {
    if (!silent) yield put(hideLoader());
  }
}

// SEARCH PARTICIPANT API CALL FUNCTION
function* getVisitListAsync(action) {
  // Silent polling (auto-refresh) skips the global loader.
  const silent = action?.payload?.silent;
  try {
    if (!silent) yield put(showLoader());
    const response = yield DashboardService.getVisitList(action?.payload);
    const { status } = response;
    if (status) {
      const { data } = response;
      yield put(setVisitList(data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setVisitList({}));

    console.log("err: ", error);
  } finally {
    if (!silent) yield put(hideLoader());
  }
}

// GET FACILITY ROOMS ASYNC (dashboard room assignments widget)
function* getFacilityRoomsAsync(action) {
  try {
    const response = yield DashboardService.getFacilityRooms(action?.payload);
    const { status, data } = response;
    if (status && data?.success) {
      yield put(setFacilityRooms(data?.rooms || []));
    }
  } catch (error) {
    yield put(setFacilityRooms([]));
    console.log("err: ", error);
  }
}

// GET ICD/DSM SUMMARY ASYNC (dashboard ICD codes widget)
// Never blocks the screen with the global loader — the card owns its own
// filter and refetches on every window change.
function* getIcdSummaryAsync(action) {
  try {
    const response = yield DashboardService.getIcdSummary(action?.payload);
    const { status, data } = response;
    if (status && data?.success) {
      yield put(setIcdSummary(data));
    }
  } catch (error) {
    yield put(setIcdSummary({}));
    console.log("err: ", error);
  }
}

function* rootSaga() {
  yield all([takeLatest(getDashboardData().type, getDashboardCountAsync)]);
  yield all([takeLatest(getVisitList().type, getVisitListAsync)]);
  yield all([takeLatest(getFacilityRooms().type, getFacilityRoomsAsync)]);
  yield all([takeLatest(getIcdSummary().type, getIcdSummaryAsync)]);
}

store.sagaManager.addSaga(componentKey, rootSaga);
